import { render, staticRenderFns } from "./SendFiles.vue?vue&type=template&id=122cff58&scoped=true"
import script from "./SendFiles.vue?vue&type=script&lang=js"
export * from "./SendFiles.vue?vue&type=script&lang=js"
import style0 from "./SendFiles.vue?vue&type=style&index=0&id=122cff58&prod&scoped=true&lang=css"
import style1 from "./SendFiles.vue?vue&type=style&index=1&id=122cff58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122cff58",
  null
  
)

export default component.exports